<ng-container *ngIf="visible">

    <mat-progress-bar [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>

</ng-container>
